/** * @Author: liujiannan * @Date: 2020-09-22 13:28:21 * @Description 首页门诊
*/
<template>
  <div class="home-outpatient">
    <Banners :list="bannerList" />
    <div class="home-outpatient-main-function">
      <HomeCardInfo :card="defaultCard" />
      <div @click="goServe()" class="home-outpatient-main-function-serve"></div>
      <div class="home-outpatient-main-function-list">
        <div
          v-for="(item, index) in mainMenuList"
          :key="index"
          :class="
            index == 0
              ? 'home-outpatient-main-function-list-blue'
              : 'home-outpatient-main-function-list-orange'
          "
          @click="routeTo(item)"
        >
          <img v-if="item.icon" v-lazy="item.icon" alt="" />
          <div>{{ item.menuname }}</div>
        </div>
      </div>
    </div>
    <van-dialog v-model="showDialog" title="预约须知" @confirm="confirmClick()">
      <div style="padding: 1rem; overflow-y: scroll; max-height: 60vh">
        一、本院实行实名就诊制，预约号上的名字须和就诊名字一致（不允许张三名字预约，李四来就诊）。<br />
        二、尽量使用社保卡进行预约。<br />
        三、进行无卡预约时，就诊前一定要到自助机取号确定。<br />
        （1）如果手中无卡则须到收费处办理就诊卡；<br />
        （2）如果手中有社保卡则要确保该卡在我院已开通，如无法确定，请到收费处开通。<br />
      </div>
    </van-dialog>
    <HorizontalScrollFunctions
      :list="functionList"
      @routeTo="routeTo"
      style="display: block"
    />
    <ModuleFunctions
      v-for="(item, index) in subMenuList"
      :key="index"
      :list="item.child"
      :title="item.menuname"
      @routeTo="routeTo"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Banners from "./components/Banners";
import HorizontalScrollFunctions from "./components/HorizontalScrollFunctions";
import ModuleFunctions from "./components/ModuleFunctions";
import HomeCardInfo from "./components/HomeCardInfo";

export default {
  components: {
    Banners,
    HorizontalScrollFunctions,
    ModuleFunctions,
    HomeCardInfo,
  },
  data() {
    return {
      tabActive: 0,
      bannerList: [],
      mainMenuList: [],
      functionList: [],
      subMenuList: [],
      defaultCard: {},
      showDialog: false,
    };
  },
  activated() {
    /*
    this.$phdialog
      .confirm({
        message: "根据上级部门通知，我院开展门诊预缴金清退工作。请查看本人或亲属在我院门诊预交金是否尚有余额，尽快按照提示进行清退。",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      })
      .then(() => {
        let url = {
          menuname: "在线退款(按电话)",
          icon: "https://app.fjlyrmyy.com/palmhospital/icons/350802/icon_daily_report.png", // 临时图标，可替换为实际图标
          url: "/onlineRefundQuery",
          linkType: "1",
          functionType: "1"
        };
        this.routeNavigate(url);
      })
      .catch(() => {});
    */
    this.initData();
    this.archive();
    this.showDialog = false;
  },
  methods: {
    ...mapActions("users", ["getUserBaseQrcodeInfo", "getUserBaseInfo"]),
    ...mapActions("home", ["routeNavigate"]),
    archive() {
      this.$http
        .post(this.$api.USER_QRCODE_ARCHIVE, {
          functionType: "1",
        })
        .then(() => {});
    },
    routeTo(item) {
      if (item.menuname == "预约挂号") {
        this.showDialog = true;
      } else {
        this.routeNavigate(item);
      }
    },
    confirmClick() {
      // this.$http
      //   .post(this.$api.USER_BASE_INFO, {
      //     functionType: "1",
      //   })
      //   .then((res) => {
      console.log("1");
      this.showDialog = false;
      this.$router.push({
        name: "department-list",
      });
      // })
      // .catch(() => {
      //   console.log("2");
      //   alert("请先绑卡");
      // });
    },
    initData() {
      this.$http
        .post(this.$api.HOME, { functionType: "1" }, false)
        .then((res) => {
          const { menuList, advimgList, hasBind } = res;
          if (hasBind === "0") {
            this.$router.push({
              name: "relative-phone",
            });
            return;
          }
          this.bannerList = advimgList;
          this.mainMenuList = menuList[0].child;
          this.functionList = menuList[1].child;
          
          // 添加在线退款功能入口
          const refundItem = {
            menuname: "在线退款",
            icon: "https://app.fjlyrmyy.com/palmhospital/icons/350802/icon_daily_report.png", // 临时图标，可替换为实际图标
            url: "/onlineRefund",
            linkType: "1",
            functionType: "1"
          };

          // 添加在线退款(按电话)功能入口
          const queryItem = {
            menuname: "在线退款(按电话)",
            icon: "https://app.fjlyrmyy.com/palmhospital/icons/350802/icon_daily_report.png", // 临时图标，可替换为实际图标
            url: "/onlineRefundQuery",
            linkType: "1",
            functionType: "1"
          };
          
          // 保存原第四个功能项（用于后续移动到第六位）
          let fourthItem = null;
          if (this.functionList.length >= 4) {
            fourthItem = this.functionList[3];
            this.functionList.splice(3, 1); // 移除原第四个功能项
          }

          // 将在线退款(按电话)插入到第四个位置（索引3）
          if (this.functionList.length >= 3) {
            this.functionList.splice(3, 0, queryItem);
          } else {
            this.functionList.push(queryItem);
          }

          // 如果功能列表少于4个，将在线退款放在最后；否则插入到第5个位置（索引4）
          if (this.functionList.length < 4) {
            this.functionList.push(refundItem);
          } else {
            this.functionList.splice(4, 0, refundItem);
          }

          // 如果有原第四个功能项，将其放到第六个位置（索引5）
          if (fourthItem && this.functionList.length >= 6) {
            this.functionList.splice(5, 0, fourthItem);
          } else if (fourthItem) {
            this.functionList.push(fourthItem);
          }
          
          const newList = [];
          for (let i = 2; i < menuList.length; i += 1) {
            newList.push(menuList[i]);
          }
          this.subMenuList = newList;
          if (res.hospitalDefaultCard) {
            const cardInfo = res.hospitalDefaultCard;
            this.defaultCard = {
              ...cardInfo,
              cardNo: this.$regular.desensitization(cardInfo.cardNo, 3, -3),
              name: this.$regular.desensitization(cardInfo.name, 0, -1),
            };
          }
          // this.defaultCard = res.hospitalDefaultCard;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.home-outpatient {
  width: 100%;
  &-main-function {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 2rem);
    padding: 1rem;
    background: white;
    border-radius: 1rem 1rem 0 0;
    box-shadow: 0 0 1rem 0 rgba(228, 228, 228, 0.3);
    &-list {
      right: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      float: right;
      width: 50%;
      height: 11.2rem;

      div {
        display: flex;
        align-items: center;
        width: 100%;
        height: 5.27rem;
        font-weight: 500;
        font-size: 1rem;
        background-repeat: no-repeat;
        background-position: right center;
        background-size: 100% 100%;

        img {
          flex-shrink: 0;
          width: 2.37rem;
          height: 2.37rem;
          margin-right: 0.7rem;
          margin-left: 1rem;
        }
      }
      &-blue {
        color: #04b67a;
        background-image: url("~@/assets/bg_home_topfunction_blue.png");
      }
      &-orange {
        color: #09f;
        background-image: url("~@/assets/ic_home_list_blue.png");
      }
    }
  }
}
</style>
